export default __webpack_public_path__ + "static/media/chevron-right.2c222d4c.svg";